<script>
  export let loading = false;
  export let focus = false;
  export let mobile = false;
  export let user;
  export let searchTerm = '';
  import { goto } from '$app/navigation';
  import Input from '@components/Input.svelte';

  let searchInputEl;
  $: if (searchInputEl && focus) {
    searchInputEl.focus();
  }

  let searchPlaceholder = '';

  if (user) {
    searchPlaceholder = user.name.length > 10 && mobile ? 'Search this profile' : `Search ${user.name}'s profile`;
  }

  let searchSubmitted = () => {
    searchTerm = searchInputEl.value;
    goto(`/${user.username}/search?query=${searchTerm}`);
  };
</script>

<style style="text/scss" lang="scss">
  @import '../../../vendor/design-system.scss';

  .ui-search {
    margin-bottom: 20px;
    &.mobile {
      margin-bottom: 0px;
    }
  }
</style>

<div class:mobile={mobile} class="ui-search">
  <form class="ui-search-input" on:submit|preventDefault|stopPropagation={searchSubmitted}>
    <Input
      bind:inputEl={searchInputEl}
      type="text"
      disabled={loading}
      value={searchTerm}
      leftIconPath={'/images/search-icon.svg'}
      placeholder={loading || !user ? '' : searchPlaceholder}
      loading={loading} />
  </form>
</div>
